export default __webpack_public_path__ + "static/media/business_partner_13.c36dd99c.png";